export type PublicProfileData = {
  id: string;
  display_name: string | null;
  slug: string | null;
  bio?: string | null;
  avatar_url: string | null;
  is_public: boolean;
  profile_hidden: boolean;
  followers_count: number;
  following_count: number;
  you_follow: boolean;
  follows_you: boolean;
  level: number | null;
  status: null | { code: string; name: string };
};

export async function fetchPublicProfile(reference: string): Promise<PublicProfileData> {
  const response = await fetch(`/api/v1/profiles/${encodeURIComponent(reference)}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Public profile failed: ${response.status}`);
  }

  return response.json() as Promise<PublicProfileData>;
}
